import GridView from "../../components/controls/GridView/GridView";
import accountGroupService, {
  AccountGroup,
} from "../../services/accountGroupService";
import { MenuItem } from "../../models/menu";
import { useEffect, useState } from "react";
import FormModal from "../../components/controls/FormModal/FormModal";
import { AccountCacheService } from "../../services/accountService";
import { MdSave } from "react-icons/md";
import Frame from "../../components/controls/Frame/Frame";
import ContextMenu from "../../components/controls/ContextMenu/ContextMenu";

export interface AccountGroupListingProps {
  showSearchBar?: boolean;
  showAddButtonInSearchBar?: boolean;
  isModal?: boolean;
}

export const AccountGroupListing = (props: AccountGroupListingProps) => {
  const [accountGroups, setAccountGroups] = useState<AccountGroup[]>([]);
  const [showAddAccountGroup, setShowAccountGroup] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const accountCacheService = new AccountCacheService();

  const maxPageRecords = 20;

  var contextMenu: MenuItem<AccountGroup>[] = [
    new MenuItem("Delete", (e: AccountGroup) => {
      //TODO: prepare a component for confirm and alert dialog box
      const ans = window.confirm(
        "Are you sure you want to delete group " +
          e.name +
          " all it's sub group.\n" +
          +"This action cannot be reversed"
      );

      if (ans !== true) return;
      const deleteFn = async (id: number) => {
        const resp = await accountGroupService.deleteAccountGroup(id);
        if (resp?.status) {
          alert(`Account group ${e.name} deleted successfully`);
          setAccountGroups(accountGroups.filter((d) => d.id !== e.id));
        }
      };

      deleteFn(e.id ?? 0);
    }),
    new MenuItem("Edit", (e: AccountGroup) => {
      // navigate('/app/account-group?gid=' + e.id);
      editAccountGroup(e);
    }),
  ];

  const editAccountGroup = (accGroup: AccountGroup) => {
    setShowAccountGroup(true);
  };

  const findAccountGroup = async (name: string) => {
    const resp = await accountGroupService.getAccountGroups({
      name: name,
      pageNo: currentPage,
      pageSize: maxPageRecords,
    });

    if (resp.status) {
      setAccountGroups(resp.data ?? []);
    }
  };

  useEffect(() => {
    findAccountGroup("");
  }, []);

  return (
    <div className="row">
      <div className="col">
        <Frame>
          <h4>Account Groups (COA)</h4>
          <GridView
            onSearchValueChanged={(query) => findAccountGroup(query)}
            keys={["name"]}
            context="Account groups"
            showSearchBar={true}
            rowsPerPage={maxPageRecords}
          >
            <GridView.Header>
              <thead>
                <tr>
                  <th>Group Code</th>
                  <th>Account Group Name</th>
                  <th>Action(s)</th>
                </tr>
              </thead>
            </GridView.Header>
            <GridView.Content>
              {accountGroups.map((d) => (
                <tr>
                  <td>{d.code}</td>
                  <td>{d.name}</td>
                  <td>
                    <ContextMenu menu={contextMenu} item={d} />
                  </td>
                </tr>
              ))}
            </GridView.Content>
          </GridView>

          {showAddAccountGroup && (
            <FormModal onClose={() => setShowAccountGroup(false)}>
              <AccountGroupForm />
            </FormModal>
          )}
        </Frame>
      </div>
    </div>
  );
};

export type AccountGroupFormProps = {
  onSetData?: (accountGroup: AccountGroup) => void;
};

export function AccountGroupForm(props: AccountGroupFormProps) {
  const [accountGroup, setAccountGroup] = useState<AccountGroup>({});
  const [isLoading, setIsLoading] = useState(false);
  const accountCacheService = new AccountCacheService();

  const toggleIsLoading = () => setIsLoading(!isLoading);

  return (
    <div>
      <div className="row">
        <div className="col-7">
          {/* <h3>Account Group</h3> */}
          <div className="row">
            <div className="col-7">
              <div className="form-group">
                <label htmlFor="accountGroupName" className="control-label">
                  Name
                </label>
                <input
                  type="text"
                  id="accountGroupName"
                  name="accountGroupName"
                  placeholder="Enter the group Name"
                  value={accountGroup.name}
                  onChange={(e) => {
                    if (e.currentTarget.value !== "") {
                      setAccountGroup({
                        ...accountGroup,
                        name: e.currentTarget.value,
                      });
                    }
                  }}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-5">
              <div className="form-group">
                <label htmlFor="accountGroupCode" className="control-label">
                  GroupCode
                </label>
                <input
                  type="number"
                  name="accountGroupCode"
                  id="accountGroupCode"
                  className="form-control"
                  value={accountGroup.code}
                  onChange={(e) => {
                    if (e.currentTarget.value !== "") {
                      setAccountGroup({
                        ...accountGroup,
                        name: e.currentTarget.value,
                      });
                    }
                  }}
                />
              </div>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="parentGroup" className="control-label">
              Parent Group
            </label>
            <select
              name="parentGroup"
              id="parentGroup"
              className="form-control"
              onChange={(e) => {
                if (accountGroup !== undefined) {
                  setAccountGroup({
                    ...accountGroup,
                    parentGroupId: Number(e.currentTarget.value),
                  });
                  return;
                }

                setAccountGroup({
                  parentGroupId: Number(e.currentTarget.value),
                });
              }}
            >
              <option>Select Parent Group</option>
              {accountCacheService.getAccountGroups().map((d) => (
                <option value={d.id}>{d.name}</option>
              ))}
            </select>
          </div>

          <hr />
          <div className="form-group">
            <button
              className="btn btn-primary"
              onClick={(e) => {
                toggleIsLoading();
                e.preventDefault();

                if (accountGroup === undefined) return;

                const saveAccountGroupFn = async () => {
                  const resp =
                    await accountGroupService.createOrUpdateAccountGroup(
                      accountGroup
                    );
                  alert(resp?.message);

                  if (resp?.status) {
                    setAccountGroup({});
                  }

                  toggleIsLoading();
                };

                saveAccountGroupFn();
              }}
            >
              {isLoading && <MdSave />} Save changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
